import React, { useState } from "react";
import _uniqueId from "lodash/uniqueId";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function FieldDatepicker({
  label,
  information,
  value,
  style,
  onChange,
  required = false,
  disabled = false,
  readonly = false,
  className = "",
  error,
  monthYearPicker,
  dateFormat,
  customInput,
  selectsStart = false,
  selectsEnd = false,
  startDate,
  endDate,
  minDate,
  maxDate
}) {
  const [id] = useState(_uniqueId("field_"));

  return (
    <div className={"form-group " + className} style={style}>
      <label htmlFor={id}>{label}</label>
      <DatePicker
        className={className}
        readonly={readonly}
        required={required}
        disabled={disabled}
        id={id}
        selected={value}
        onChange={onChange}
        dateFormat={dateFormat}
        showMonthYearPicker={monthYearPicker}
        customInput={customInput}
        selectsStart={selectsStart}
        selectsEnd={selectsEnd}
        startDate={startDate}
        endDate={endDate}
        minDate={minDate}
        maxDate={maxDate}
        showPopperArrow={false}
      />

      {information ? (
        <small id={id + "Help"} className="form-text text-muted">
          {information}
        </small>
      ) : null}
      {error ? (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {error}
        </div>
      ) : null}
    </div>
  );
}
